export default __webpack_public_path__ + "static/media/Logout.75d4b7d6.svg";